__turbopack_context__.v({
  "cardContent": "CardLink-module-scss-module__0EpNka__cardContent",
  "cardContentContainer": "CardLink-module-scss-module__0EpNka__cardContentContainer",
  "cardImage": "CardLink-module-scss-module__0EpNka__cardImage",
  "cardLink": "CardLink-module-scss-module__0EpNka__cardLink",
  "cardLinkBorder": "CardLink-module-scss-module__0EpNka__cardLinkBorder",
  "date": "CardLink-module-scss-module__0EpNka__date",
  "readMoreIcon": "CardLink-module-scss-module__0EpNka__readMoreIcon",
});
